import type { InterviewPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';

// Carries the server's JSON as received, exactly like `INTERVIEW_CHANGED`: `conductedOn` is still the
// wire string, converted by the store handler, which both actions share.
export type InterviewRenamedAction = {
	type: 'INTERVIEW_RENAMED';
	payload: InterviewPayload;
	typeKey: string;
	subjectId: number;
};

export default (payload: InterviewPayload, typeKey: string, subjectId: number): InterviewRenamedAction => ({
	type: 'INTERVIEW_RENAMED',
	payload,
	typeKey,
	subjectId,
});
